import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import topTitle from '@/components/title';
import { orderDetail } from './request';
import RefundModel from './refundModel.vue';
export default {
  components: {
    topTitle,
    RefundModel
  },
  data() {
    return {
      refundShow: false,
      dataFrom: {
        customerInsuranceName: {}
      },
      data: [],
      columns: [{
        slots: {
          title: '产品名称'
        },
        dataIndex: 'name',
        key: '1',
        align: 'center'
      }, {
        slots: {
          title: '产品类型'
        },
        dataIndex: 'productType',
        key: '4',
        align: 'center',
        scopedSlots: {
          customRender: 'productType'
        }
      }, {
        slots: {
          title: '方案名称'
        },
        dataIndex: 'planName',
        key: 'planName',
        align: 'center'
      },
      // {title: '方案代码', dataIndex: 'mark', key: '2', align: 'center'},
      // {title: '产品标识', dataIndex: 'code', key: '3', align: 'center'},
      {
        slots: {
          title: '保障额度'
        },
        dataIndex: 'amount',
        key: '5',
        align: 'center'
      }, {
        slots: {
          title: '区域'
        },
        dataIndex: 'area',
        key: 'area',
        align: 'center'
      }, {
        slots: {
          title: '保费'
        },
        dataIndex: 'price',
        key: '6',
        align: 'center'
      }, {
        slots: {
          title: '折扣保费'
        },
        dataIndex: 'discountPrice',
        key: 'discountPrice',
        align: 'center'
      }]
    };
  },
  created() {
    orderDetail({
      orderId: this.$route.params.id
    }).then(res => {
      var _this$data;
      this.dataFrom = res;
      this.data = res.product;
      if (!((_this$data = this.data) !== null && _this$data !== void 0 && (_this$data = _this$data[0]) !== null && _this$data !== void 0 && _this$data.discountPremium)) {
        //无折扣信息时不展示折扣保费
        this.columns = this.columns.filter(item => item.dataIndex !== 'discountPrice');
      } else {
        this.data = this.data.map(item => {
          if (item.discountPremium && Object.keys(item.discountPremium).length) {
            item.discountPrice = this.computedDiscountPrice(item.price, item.discountPremium);
          } else {
            item.discountPrice = '-';
          }
          return item;
        });
      }
    });
  },
  methods: {
    detailedFun() {
      this.refundShow = true;
      this.$nextTick(() => {
        this.$refs.refundFrom.init(this.dataFrom.refundDetail);
      });
    },
    getValue(discountInfo) {
      if (discountInfo.discountMode === 'ratio') {
        let result = discountInfo.discountRatio ? discountInfo.discountRatio + '%' : '-';
        return result;
      } else if (discountInfo.discountMode === 'amount') {
        let result = discountInfo.discountAmount ? '-' + discountInfo.discountAmount : discountInfo.discountAmount;
        return result;
      }
    },
    computedDiscountPrice(value, discountRule) {
      let result = '-';
      if (!value) {
        return result;
      }
      if (discountRule) {
        const num = discountRule.discountMode === 'ratio' ? discountRule.discountRatio : discountRule.discountAmount;
        if (num <= 0) {
          this.$message.error(this.$t('必须输入大于0的数字'));
          return result;
        }
        if (discountRule.discountMode == 'ratio' && num >= 100) {
          this.$message.error(this.$t('折扣比例必须小于100的数字'));
          return result;
        }
        if (discountRule.discountMode === 'ratio') {
          result = Number(Number(value) * 100 - Number(value) * 100 * Number(discountRule.discountRatio / 100)) / 100;
        }
        if (discountRule.discountMode === 'amount') {
          result = Number(Number(value) * 100 - Number(discountRule.discountAmount) * 100) / 100;
        }
        result = result > 0 ? parseFloat(result).toFixed(2) : 0;
        return result;
      }
    }
  }
};